module.exports = __webpack_public_path__ + "media/images/technopark/website-8ef5a0e51f38c765d74d929dd7b504f2.png";